import {DateTimePicker} from '@mantine/dates';
import classes from './date-time-picker.module.css';

export const DateTimePickerTheme = DateTimePicker.extend({
  classNames: {
    day: classes.day,
  },
});